import { getApiBase } from '../config'
import { getModel, setAuthToken, setInitialModel } from './Model'

export const getApiPath = (path) => {
	return `${getApiBase()}${path}`
}

export const requestAPIWithFormData = (path, method, formData) => {
	return fetch(getApiPath(path), {
		method: method,
		body: formData,
		headers: {
			Accept: 'application/json, text/plain, */*',
			'X-Copyright-Agent-Auth-Token': getModel().auth_token,
		},
	})
		.then(async (res) => {
			if (
				!!res.headers.get('content-type') &&
				res.headers.get('content-type').includes('application/json')
			) {
				try {
					const json = await res.json()
					return json
				} catch (err) {
					return res
				}
			}
			return res
		})
		.then((res) => {
			if (res.status === 'Not authenticated.') {
				setAuthToken('')
				setInitialModel()
				return
			}
			return res
		})
}

export const requestAPI = (path, method, data) => {
	return fetch(getApiPath(path), {
		method: method,
		body: JSON.stringify(data),
		headers: {
			Accept: 'application/json, text/plain, */*',
			'Content-Type': 'application/json',
			'X-Copyright-Agent-Auth-Token': getModel().auth_token,
		},
	})
		.then(async (res) => {
			if (
				!!res.headers.get('content-type') &&
				res.headers.get('content-type').includes('application/json')
			) {
				try {
					const json = await res.json()
					return json
				} catch (err) {
					return res
				}
			}
			return res
		})
		.then((res) => {
			if (res.status === 'Not authenticated.') {
				setAuthToken('')
				setInitialModel()
				return
			}
			return res
		})
}

export async function get(path) {
	const response = await fetch(getApiPath(path), {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'X-Copyright-Agent-Auth-Token': getModel().auth_token,
		},
	})
	if (response.status === 404) return
	if (response.status !== 200)
		throw new Error({ message: 'Unhandled response', response })

	const body = await response.json()

	return body
}

export async function statusRequestAPI(path, method, data) {
	const response = await fetch(getApiPath(path), {
		method: method,
		body: JSON.stringify(data),
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			'X-Copyright-Agent-Auth-Token': getModel().auth_token,
		},
	})
	console.log(response, response.status)
	if (response.status === 404) return false
	if (response.status !== 200)
		throw new Error({ message: 'Unhandled response', response })

	return true
}

async function errorMessage(response) {
	const contentType = response.headers.get('content-type')
	if (!contentType || !contentType.includes('application/json')) {
		return `Request failed (${response.status})`
	}

	const body = await response.json()

	return body.message || body.code || `Request failed (${response.status})`
}

export async function post(path, data) {
	const response = await fetch(getApiPath(path), {
		method: 'POST',
		body: JSON.stringify(data),
		headers: {
			Accept: 'application/json, text/plain, */*',
			'Content-Type': 'application/json',
			'X-Copyright-Agent-Auth-Token': getModel().auth_token,
		},
	})

	if (!response.ok) throw new Error(await errorMessage(response))

	return response
}
